<div class="bg-white rounded-lg border border-gray-200 p-8">
  <div class="mb-6">
    <h1 class="text-2xl font-bold text-primary mb-1">6. Revisión de documentos</h1>
    <p class="text-gray-600">Revisa los documentos para aceptarlos y firmarlos digitalmente.</p>
  </div>

  <a href="#" class="text-primary hover:underline flex items-center text-sm py-3 px-1 mb-4">
    Revisar y firmar documento
    <span class="ml-1 h-3 w-3">&#8599;</span>
  </a>

  <div class="space-y-4 mb-8">
    <div *ngFor="let key of getDocumentKeys()">
      <div class="border border-gray-200 rounded-lg p-4">
        <div class="flex items-center justify-between">
          <div class="flex-1">
            <h3 class="font-medium text-gray-700">
              {{ DOCUMENTS_INFO[key].title }}
              <ng-container *ngIf="DOCUMENTS_INFO[key].required">
                <span class="text-gray-400 font-normal">(obligatorio)</span>
                <span class="text-red-500">*</span>
              </ng-container>
            </h3>
          </div>
          <div class="flex items-center gap-4">
            <button *ngIf="documentosFirmados[key]" type="button" class="btn btn-outline-secondary border-gray-300 text-gray-700">
              Revisar documento
            </button>
            <button *ngIf="!documentosFirmados[key]" type="button" class="btn text-white" style="background-color: #3abfad;" (click)="onOpenDocument(key, DOCUMENTS_INFO[key].title)">
              Firmar documento
            </button>
            <div class="flex items-center gap-2 font-medium" [ngClass]="documentosFirmados[key] ? 'text-primary' : 'text-amber-500'">
              <ng-container *ngIf="documentosFirmados[key]; else notSigned">
                <div class="w-5 h-5 bg-primary rounded-full flex items-center justify-center">
                  <span class="text-white">&#10003;</span>
                </div>
                <span>Firmado</span>
              </ng-container>
              <ng-template #notSigned>
                <span class="h-5 w-5">&#9888;</span>
                <span>Sin firmar</span>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Nota informativa -->
  <div class="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-6">
    <div class="flex items-start gap-2">
      <span class="h-5 w-5 text-gray-500 flex-shrink-0 mt-0.5">&#9432;</span>
      <p class="text-gray-600 text-sm">
        Recibirás una copia del contrato en tu correo electrónico una vez finalizado este proceso.
      </p>
    </div>
  </div>

  <!-- Checkbox de aceptación final -->
  <div class="flex items-start space-x-3 pt-4">
    <input type="checkbox" id="aceptacion-final" [checked]="aceptacionFinal" (change)="onCheckboxChange($event)" />
    <label
      for="aceptacion-final"
      class="text-sm leading-relaxed"
    >
      Al aceptar, estarás firmando electrónicamente
      <span class="font-medium">los documentos que has leído y aceptado previamente</span>. Una vez firmados,
      <span class="font-medium">serán enviados a tu correo electrónico</span>.
    </label>
  </div>
</div> 